import { useState } from "react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { PAPER_SIZES, COURIERS } from "../lib/couriers";
import { Settings2, Lock, Save, Layers, Trash2 } from "lucide-react";

const TOGGLES = [
  { key: "showSender", label: "Alamat Pengirim" },
  { key: "showLogo", label: "Logo Toko", pro: true },
  { key: "showItems", label: "Rincian Isi Paket" },
  { key: "showCod", label: "Nilai COD" },
  { key: "showBarcode", label: "Barcode (Code 128)" },
  { key: "showQR", label: "QR Code" },
  { key: "showFragile", label: "Ikon Fragile / Pecah Belah" },
];

export function LabelControls({ controls, setControls, defaultCourier, setDefaultCourier, isPro, onProToggle,
  templates = [], onApplyTemplate, onSaveTemplate, onDeleteTemplate }) {
  const set = (key, val) => setControls((c) => ({ ...c, [key]: val }));
  const [selectedTpl, setSelectedTpl] = useState("");

  const handleSaveTpl = () => {
    const name = window.prompt("Nama template (mis. Kaos 100x150):");
    if (name && name.trim()) onSaveTemplate?.(name.trim());
  };

  return (
    <Card className="p-5 space-y-5">
      <div className="flex items-center gap-2 text-slate-900 font-bold">
        <Settings2 size={18} className="text-sky-600" /> Pengaturan Label
      </div>

      <div className="space-y-2 pb-4 border-b border-slate-100">
        <Label className="text-xs uppercase tracking-wide text-slate-500 font-mono flex items-center gap-1">
          <Layers size={13} /> Template Gaya
        </Label>
        <div className="flex gap-2">
          <Select value={selectedTpl} onValueChange={(v) => { setSelectedTpl(v); const t = templates.find((x) => x.id === v); if (t) onApplyTemplate?.(t); }}>
            <SelectTrigger data-testid="template-select" className="flex-1">
              <SelectValue placeholder={templates.length ? "Pilih template" : "Belum ada template"} />
            </SelectTrigger>
            <SelectContent>
              {templates.map((t) => (<SelectItem key={t.id} value={t.id} data-testid={`template-option-${t.id}`}>{t.name}</SelectItem>))}
            </SelectContent>
          </Select>
          <Button data-testid="btn-save-template" variant="outline" size="icon" onClick={handleSaveTpl} title="Simpan sebagai template">
            <Save size={16} />
          </Button>
          {selectedTpl && (
            <Button data-testid="btn-delete-template" variant="ghost" size="icon" className="text-red-500"
              onClick={() => { onDeleteTemplate?.(selectedTpl); setSelectedTpl(""); }} title="Hapus template">
              <Trash2 size={16} />
            </Button>
          )}
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-wide text-slate-500 font-mono">Ukuran Kertas</Label>
        <Select value={controls.paperSize} onValueChange={(v) => set("paperSize", v)}>
          <SelectTrigger data-testid="paper-size-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(PAPER_SIZES).map(([k, v]) => (
              <SelectItem key={k} value={k} data-testid={`paper-size-${k}`}>{v.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-wide text-slate-500 font-mono">Ekspedisi Default</Label>
        <Select value={defaultCourier} onValueChange={setDefaultCourier}>
          <SelectTrigger data-testid="courier-select-dropdown"><SelectValue placeholder="Pilih ekspedisi" /></SelectTrigger>
          <SelectContent>
            {COURIERS.map((c) => (
              <SelectItem key={c.value || "none"} value={c.value || "none"}>{c.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3 pt-1">
        <Label className="text-xs uppercase tracking-wide text-slate-500 font-mono">Elemen Label</Label>
        {TOGGLES.map((t) => {
          const locked = t.pro && !isPro;
          return (
            <div key={t.key} className="flex items-center justify-between">
              <span className="text-sm text-slate-700 flex items-center gap-1.5">
                {t.label}
                {locked && <Lock size={12} className="text-orange-500" />}
              </span>
              <Switch
                data-testid={`toggle-${t.key}`}
                checked={!!controls[t.key] && !locked}
                onCheckedChange={(v) => {
                  if (locked) { onProToggle?.(); return; }
                  set(t.key, v);
                }}
              />
            </div>
          );
        })}
      </div>
    </Card>
  );
}
